import { render, staticRenderFns } from "./product.vue?vue&type=template&id=704bf335&scoped=true&"
import script from "./product.vue?vue&type=script&lang=ts&"
export * from "./product.vue?vue&type=script&lang=ts&"
import style0 from "./product.vue?vue&type=style&index=0&id=704bf335&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704bf335",
  null
  
)

component.options.__file = "product.vue"
export default component.exports